module.exports = __webpack_public_path__ + "static/media/sign-writer.2e38bbd7.jpg";